import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {
  DEVICES_ROUTE,
  MAIN_ROUTE,
  SIGN_IN_ROUTE,
  USERS_ROUTE,
} from '../../constant/routes';
import { DevicesPage } from '../../page/DevicesPage';
import { MainPage } from '../../page/MainPage';
import { SignInPage } from '../../page/SignInPage';
import { ModelsPage } from '../../page/ModelsPage';
import { UserPage } from '../../page/UserPage';

export const App = () => (
  <div>
    <Routes>
      <Route path={SIGN_IN_ROUTE} element={<SignInPage />} />
      <Route path={MAIN_ROUTE} element={<MainPage />} />
      <Route path={DEVICES_ROUTE} element={<DevicesPage />} />
      <Route path={USERS_ROUTE} element={<UserPage />} />
      <Route path={`${DEVICES_ROUTE}/:parSiId`} element={<ModelsPage />} />
      <Route
        path={`${DEVICES_ROUTE}/:parSiId/:parModelId`}
        element={<ModelsPage />}
      />
      <Route
        path={`${DEVICES_ROUTE}/:parSiId/:parModelId/:parPodModelId`}
        element={<ModelsPage />}
      />
    </Routes>
  </div>
);

export default App;
